<template>
  <div class="root">
    <!-- style="flex:3;" -->
    <div class="left" >
        <div class="left-title-view">
            <div class="left-title">今日采购</div>
            <div class="left-more" @click="moreClick">更多
                <i class="el-icon-arrow-right"/>
            </div>
        </div>
        <div class="left-table-view">
            <el-table
                :data="tableData"
                height="400"
                size="mini">
                <el-table-column
                    prop="pinzhong"
                    label="采购品种"
                    >
                </el-table-column>
                <el-table-column
                    prop="caigouliang"
                    label="采购量">
                </el-table-column>
                <el-table-column
                    prop="shouhuodi"
                    label="收货地">
                </el-table-column>
                <el-table-column
                    prop="caigoufang"
                    label="采购方"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="baojia"
                    label="报价情况"
                    width="100">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="80"
                    header-align="center">
                    <template slot-scope="scope">
                        <el-button @click="quotationClick(scope.row)" class="table-button" type="text" size="small">我要报价</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <!-- style="flex:1;" -->
    <div class="right">
        <div class="right-top">
            <div class="right-top-title">采购数据</div>
            <div class="right-top-info">
                <div class="info-inquiry">正在询价
                    <h3>{{inquiry}}</h3>
                </div>
                <div class="info-quotation">当前报价
                    <h3>{{quotation}}</h3>
                </div>
            </div>
        </div>
         <div class="right-bottom">
            <div class="right-bottom-title">最新报价</div>
            <div class="right-bottom-info">
                <el-table
                    :data="lastTableData"
                    height="280">
                    <el-table-column
                        prop="pinzhong"
                        label="采购品种"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="zuixinbaojia"
                        width="120"
                        label="最新报价">
                    </el-table-column>
                    <el-table-column
                        prop="baojiashijian"
                        label="报价时间">
                    </el-table-column>
                </el-table>
            </div>
         </div>
    </div>

    <el-dialog
        :visible.sync="dialogVisible"
        width="30%">
        <span>{{dialogTitle}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import {
    getList, getBidList, getCount
} from '@/api/home/procure.js'

import {mapMutations} from 'vuex'
export default {
  props: ['afterSaleList', 'page', 'total'],
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '',
      tableData: [{
            pinzhong: '蜂蜜',
            caigouliang: '8000个/天',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '李**',
            baojia: '待报价',
        }, {
            pinzhong: '油',
            caigouliang: '5000斤/每次',
            shouhuodi: '湖北省/武汉市',
            caigoufang: 'hn1****00',
            baojia: '3人报价',
        }, {
            pinzhong: '红糖',
            caigouliang: '60000斤/每次',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '赖**',
            baojia: '待报价',
        }, {
            pinzhong: '大米',
            caigouliang: '30000公斤/每月',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '邹**',
            baojia: '待报价',
        }, {
            pinzhong: '面',
            caigouliang: '4000斤/每月',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '徐**',
            baojia: '3人报价',
        }, {
            pinzhong: '皮蛋',
            caigouliang: '30000个/每天',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '陈**',
            baojia: '1人报价',
        }, {
            pinzhong: '花菇',
            caigouliang: '100斤/每月',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '唐**',
            baojia: '3人报价',
        }, {
            pinzhong: '红菇',
            caigouliang: '60000斤/每次',
            shouhuodi: '湖北省/武汉市',
            caigoufang: '陶**',
            baojia: '1人报价',
      }],
      lastTableData: [{
            pinzhong: '蜂蜜',
            zuixinbaojia: '1元/斤',
            baojiashijian: '1分钟前',
        }, {
            pinzhong: '油',
            zuixinbaojia: '25元/斤',
            baojiashijian: '1分钟前',
        }, {
            pinzhong: '红糖',
            zuixinbaojia: '30元/斤',
            baojiashijian: '1分钟前',
        }, {
            pinzhong: '大米',
            zuixinbaojia: '1元/斤',
            baojiashijian: '1分钟前',
        }, {
            pinzhong: '面',
            zuixinbaojia: '1元/斤',
            baojiashijian: '1分钟前',
        }, {
            pinzhong: '皮蛋',
            zuixinbaojia: '1元/斤',
            baojiashijian: '1分钟前',
        }],
      inquiry: 10892, // 正在询价
      quotation: 55263, // 当前报价
    }
  },
  mounted () {
    this.getList()
    this.getBidList()
    this.getCount()
  },
  methods: {
    ...mapMutations({
      setHomeSelectIndex: 'SET_HOMESELECTINDEX'
    }),
    async getList () {
        // var _this = this
        this.tableData = []
        let params = {
            'endTime': '',
            'page': 1,
            'pageSize': 10,
            'productName': '',
            'productType': '',
            'startTime': '',
            'type': 1 // 1采购 2供货
        }
        const response = await getList(params)
        const res = response.data
      if (res.code === '200') {
        res.data.list.forEach(item => {
            const pdata = {}
            pdata.pinzhong = item.productType
            pdata.caigouliang = item.stockNumber + item.packingUnit
            pdata.shouhuodi = item.deliveryPlace
            pdata.caigoufang = item.createName
            pdata.id = item.id
            pdata.baojia = item.bidNum === 0 || !item.bidNum ? '待报价' : item.bidNum + '人报价'
            this.tableData.push(pdata)
        })
      }
    },
    async getBidList () {
        // var _this = this
        this.lastTableData = []
        let params = {
            'page': 1,
            'pageSize': 10
        }
        const response = await getBidList(params)
        const res = response.data
      if (res.code === '200') {
        res.data.list.forEach(item => {
            const pdata = {}

            pdata.pinzhong = item.productType
            pdata.zuixinbaojia = item.amount + '元/' + item.packingUnit
            pdata.baojiashijian = item.bidTime

            this.lastTableData.push(pdata)
        })
      }
    },
    async getCount () {
        // var _this = this
        this.lastTableData = []
        let params = {
        }
        const response = await getCount(params)
        const res = response.data
      if (res.code === '200') {
        this.inquiry = res.data.bidNum
        this.quotation = res.data.queryNum
      }
    },
    // 更多操作
    moreClick () {
        this.dialogTitle = '点击了--更多操作'
        this.dialogVisible = true
    },
    // 我要报价点击事件
    quotationClick (item) {
      this.setHomeSelectIndex(2)
        const { id } = item
        this.$router.push({
            path: '/procureDetail',
            query: {
                id: id
            }
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.root{
  width: 100%;
  height: 515px;
  margin-top: 40px;
  padding: 1px 8vw;
  box-sizing: border-box;
  display: flex;
  .left{
    background: #fff;
    display: flex;
    flex: 4.3;
    flex-direction: column;
    padding: 20px;
    margin-right: 10px;
    box-sizing: border-box;
    // border: 1px solid #E5E5E5;
    .left-title-view {
        height: 80px;
        background-color: #fff;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        .left-title {
            display: flex;
            font-size: 18px;
            color: #333333;
            font-weight: 600;
        }
        .left-more {
            display: flex;
            flex-direction: row;
            font-size: 12px;
            color: #666666;
        }
    }
    .left-table-view {
        width: 100%;
        .table-button{
            color: #4dc832;
            border: 1px solid #4dc832;
            width:60px;
            height: 30px;
        }
    }

  }
  .right{
    width: 315px;
    // flex: 1;
    background: #fff;
    display: flex;
    flex-direction: column;

    .right-top {
        display: flex;
        flex-direction: column;
        padding: 24px 16px;
        box-sizing: border-box;
        border: 1px solid #E5E5E5;

        .right-top-title {
            width: 100%;
            display: flex;
            align-items: center;
            color: #333333;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 24px;
        }
        .right-top-info {
            display: flex;
            flex-direction: row;
            .info-inquiry, .info-quotation {
                width: 50%;
                background: #fff;
                padding: 4px 12px;
                border-radius: 4;
                border-right: 1px solid #999;
                font-size: 12px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                h3 {
                    margin-top: 12px;
                    color: #222;
                    font-size: 18px;
                    font-weight: 700;
                }
            }
            .info-quotation {
                border: none;
            }
        }
    }
    .right-bottom {
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 10px 6px;
        box-sizing: border-box;
        border: 1px solid #E5E5E5;

        .right-bottom-title {
            width: 100%;
            display: flex;
            align-items: center;
            color: #333333;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 16px;
            padding-left: 10px;
            box-sizing: border-box;
        }
        .right-bottom-info {
            display: flex;
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/procure.vue